export default __webpack_public_path__ + "static/media/bitstop-google-app-store-qr.11f260fb.png";